import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';

const items = [
    {
        icon: <SchoolRoundedIcon fontSize="large" />,
        title: 'Comprehensive Course Catalog',
        description:
            'Access a wide range of expertly curated courses covering cloud security, DevSecOps, container security, and more.',
    },
    {
        icon: <DashboardRoundedIcon fontSize="large" />,
        title: 'User-Friendly Dashboard',
        description:
            'Easily navigate through your learning journey with a centralized dashboard for progress tracking and resources.',
    },
    {
        icon: <AssessmentRoundedIcon fontSize="large" />,
        title: 'Performance Analytics',
        description:
            'Track learning progress and performance with detailed analytics to optimize your training experience.',
    },
];

export default function LMS() {
    return (
        <Box
            id="features"
            sx={{
                pt: 6,
                pb: 6,
                background: 'linear-gradient(180deg, #1a1a1a, #1f1f1f)',
                color: 'white',
            }}
        >
            <Container>
                {/* Section Header */}
                <Box textAlign="center" mb={6}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: '32px',
                            fontWeight: '600',
                            mb: 2,
                        }}
                    >
                        Learning Management System (LMS)
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.85)', mb: 4 }}>
                        Courses ranging from AWS Cloud Engineering, DevSecOps, Secure CI/CD Pipelines, Docker and Kubernetes Security, Infrastructure as Code, Cloud Security Automation, Cloud Penetration Testing, Cybersecurity Awareness, and many more.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        href="https://learn.cloudsecnetwork.com"
                        target="_blank"
                        sx={{ mt: 2 }}
                    >
                        Sign In to Platform
                    </Button>
                </Box>

                {/* Features Grid */}
                <Grid container spacing={4}>
                    {items.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index} sx={{ mb: 4 }}>
                            <Card
                                sx={{
                                    pt: 4,
                                    pb: 0,
                                    px: 3,
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                                    borderRadius: 2,
                                    backgroundColor: '#333',
                                }}
                            >
                                {/* Icon */}
                                <Box sx={{ color: 'primary.main', mb: 2 }}>{item.icon}</Box>
                                {/* Title */}
                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, color: 'white' }}>
                                    {item.title}
                                </Typography>
                                {/* Description */}
                                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.75)' }}>
                                    {item.description}
                                </Typography>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
